// src/pages/About.js
import React from "react";
import aboutTranslations from "../i18n/aboutTranslations";
import getCurrentLang from "../utils/getCurrentLang";
import "./About.css";

function SubNav({ items = [] }) {
  return (
    <nav className="about-subnav" aria-label="Section navigation">
      {items.map((it) => (
        <a key={it.href} href={it.href} className="about-subnav-link">
          {it.label}
        </a>
      ))}
    </nav>
  );
}

function TeamGrid({ profiles = [], labels = {} }) {
  const linkedinLabel = labels.linkedin || "LinkedIn";
  return (
    <div className="about-team">
      {profiles.map((m, idx) => (
        <div key={idx} className="team-member">
          <img src={m.image} alt={m.name} className="profile-pic" />
          <h3>{m.name}</h3>
          <p className="team-role">{m.role}</p>
          <p className="team-bio">{m.bio}</p>
          {m.linkedin && (
            <a href={m.linkedin} target="_blank" rel="noopener noreferrer" className="linkedin-link">
              {linkedinLabel}
            </a>
          )}
        </div>
      ))}
    </div>
  );
}

export default function About() {
  const lang = getCurrentLang();
  const t = aboutTranslations[lang] || aboutTranslations["pt"];

  // ids estáveis por ORDEM das seções
  const stableIds = [
    "missao",
    "sobre",
    "parceria",
    "atividades",
    "ecossistema",
    "modelo",
    "gestao",
    "tecnologia",
    "equipe",
  ];

  // labels do SubNav por idioma (mesma ordem dos ids acima)
  const subnavLabels = {
    pt: ["Missão", "O Kito", "Parceria", "Atividades", "Ecossistema", "Modelo", "Gestão", "Tecnologia", "Equipe"],
    en: ["Mission", "Kito", "Partnership", "Activities", "Ecosystem", "Business", "Management", "Technology", "Team"],
    es: ["Misión", "Kito", "Alianza", "Actividades", "Ecosistema", "Modelo", "Gestión", "Tecnología", "Equipo"],
  };

  const labels = subnavLabels[lang] || subnavLabels.pt;

  // monta os itens do SubNav até a quantidade de sections disponível
  const navItems = (t.sections || []).slice(0, stableIds.length).map((_, i) => ({
    href: `#${stableIds[i]}`,
    label: labels[i] || labels[0],
  }));

  const renderContent = (text) => {
    if (text === "__TEAM__") {
      return <TeamGrid profiles={t.teamProfiles || []} labels={t.labels || {}} />;
    }
    return <p dangerouslySetInnerHTML={{ __html: text }} />;
  };

  return (
    <main className="about-wrapper">
      <header className="about-hero">
        <h1 className="about-title">{t.title}</h1>
        {/* <p className="about-subtitle">Subtítulo opcional…</p> */}
      </header>

      <SubNav items={navItems} />

      <div className="about-grid">
        {(t.sections || []).map((section, idx) => (
          <section key={idx} id={stableIds[idx] || `sec-${idx}`} className="about-card">
            <h2 className="about-card-title">{section.heading}</h2>
            <div className="about-card-content">
              {(section.content || []).map((paragraph, i) => (
                <React.Fragment key={i}>{renderContent(paragraph)}</React.Fragment>
              ))}
            </div>
          </section>
        ))}
      </div>
    </main>
  );
}
